import { axiosClient } from "../../../config/axios";

export const forgotPasswordApi = async (payload) => {
		const res = await axiosClient.post("/password/recovery", payload);
		return res;
};
